import { useState } from 'react';
import PropTypes from 'prop-types';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';

import Loading from 'uI/Loading/Loading';
import UserInputs from './UserInputs/UserInputs';

import {
  setUserBilling,
  uploadConstancy
} from 'store/treasury-actions';

import classes from './DataUserBill.module.css';

const DataUserBill = props => {
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  const closeHandler = () => {
    props.close();
    setMessage('');
  };

  const setUserBillingHandler = (
    cfdiUser,
    email,
    lada,
    phone,
    automatic,
    file
  ) => {
    setLoading(true);
    (async () => {
      const userInfo = await setUserBilling(
        cfdiUser,
        email,
        lada,
        phone,
        automatic
      );
      if (file && userInfo) {
        const dataUpload = await uploadConstancy(file);
        if (dataUpload) {
          setLoading(false);
          setMessage(
            'Los datos para facturación fueron guardados exitosamente'
          );
        }
      } else {
        setLoading(false);
        setMessage(
          'Los datos para facturación fueron guardados exitosamente'
        );
      }
    })();
  };

  return (
    <Dialog
      onClose={closeHandler}
      open={props.open}
      fullWidth
      maxWidth="sm"
    >
      {!loading ? (
        <>
          {!message ? (
            <UserInputs
              userInfo={props.userInfo}
              cfdi={props.cfdi}
              close={closeHandler}
              setUserBilling={setUserBillingHandler}
            />
          ) : (
            <>
              <p className={classes.successMessage}>{message}</p>
              <div className={classes.btnsContainer}>
                <Button
                  onClick={closeHandler}
                  className={classes.acceptBtn}
                >
                  De acuerdo
                </Button>
              </div>
            </>
          )}
        </>
      ) : (
        <Loading />
      )}
    </Dialog>
  );
};

DataUserBill.propTypes = {
  // eslint-disable-next-line react/require-default-props
  userInfo: PropTypes.object,
  // eslint-disable-next-line react/require-default-props
  cfdi: PropTypes.array,
  // eslint-disable-next-line react/require-default-props
  close: PropTypes.func,
  // eslint-disable-next-line react/require-default-props
  open: PropTypes.bool
};

export default DataUserBill;
